import React from 'react'
import PropTypes from 'prop-types';

import BaseComponent from '../BaseComponent.js'

export default class CheckBox extends BaseComponent {

    render() {
        return (
            <div className={this.props.className}>
                <input id={this.props.id} checked={this.props.value} onChange={(e) => this.props.onChange(e.target.checked)}
                    type="checkbox" disabled={this.props.disabled} />
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        )
    }
}

CheckBox.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/common/CheckBox/index.js